import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ManageLicense.css"; 

const ManageLicense = () => {
  const navigate = useNavigate();

  // States
  const [stats, setStats] = useState({ total: 0, active: 0, expired: 0, disabled: 0 });
  const [licenses, setLicenses] = useState([]);
  const [filteredLicenses, setFilteredLicenses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all"); 
  const [searchTerm, setSearchTerm] = useState("");
  const [statsLoading, setStatsLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  // ==========================================
  // ১. স্ট্যাটাস ডাটা লোড করা (Stats Fetch)
  // ==========================================
  const fetchStats = async () => {
    try {
      setStatsLoading(true);
      const res = await axios.get("https://streamsrvbac.n-tools.info/keymanage/license/stats");
      
      setStats({
        total: res.data?.total || (res.data?.active + res.data?.expired + res.data?.trial) || 0,
        active: res.data?.active || 0,
        expired: res.data?.expired || 0,
        disabled: res.data?.disabled || res.data?.trial || 0, 
      });
    } catch (err) {
      console.error("Stats load error:", err);
      setStats({ total: 120, active: 80, expired: 25, disabled: 15 });
    } finally {
      setStatsLoading(false);
    }
  };

  // ==========================================
  // ২. লাইসেন্স লিস্ট ডাটা লোড করা (Table Fetch)
  // ==========================================
  const fetchLicenses = async () => {
    try {
      setTableLoading(true);
      const res = await axios.get(
        `https://streamsrvbac.n-tools.info/keymanage/license/list?status=${selectedStatus}`
      );
      const data = res.data || [];
      setLicenses(data);
      setFilteredLicenses(data);
    } catch (err) {
      console.error("License fetch error:", err);
      setLicenses([]);
      setFilteredLicenses([]);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  useEffect(() => {
    fetchLicenses();
  }, [selectedStatus]);

  // ==========================================
  // ৩. সার্চ ফিল্টারিং হ্যান্ডলার
  // ==========================================
  useEffect(() => {
    const results = licenses.filter((item) =>
      (item.client_name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.license_key || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.network_name || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredLicenses(results);
  }, [searchTerm, licenses]);

  const handleRefreshAll = () => {
    fetchStats();
    fetchLicenses();
  };

  const cards = [
    { title: "Total Licenses", value: stats.total, color: "#3b82f6", type: "all" },
    { title: "Active Licenses", value: stats.active, color: "#22c55e", type: "active" },
    { title: "Expired / Suspended", value: stats.expired, color: "#f59e0b", type: "expired" },
    { title: "Disabled / Trial", value: stats.disabled, color: "#ef4444", type: "disabled" },
  ];

  return (
  <div className="license-table-container">
    {/* টপ হেডার সেকশন WITH BACK BUTTON */}
    <div className="table-header-wrapper" style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px" }}>
      <button onClick={() => navigate("../")} className="km-back-btn" title="Back to Dashboard">
        ← Back
      </button>
      <div>
        <h2 style={{ margin: 0 }}>Manage Licenses</h2>
        <p className="subtitle" style={{ margin: 0 }}>Track, generate, and control system usage licenses.</p>
      </div>
    </div>

      {/* স্ট্যাটাস গ্রিড কার্ডস */}
      <div className="manage-license-grid">
        {cards.map((c, i) => (
          <div
            key={i}
            className={`manage-license-card ${selectedStatus === c.type ? "manage-license-active-card-filter" : ""}`}
            style={{ borderTop: `4px solid ${c.color}` }}
            onClick={() => setSelectedStatus(c.type)}
          >
            <h3>{c.title}</h3>
            <p>{statsLoading ? "..." : c.value}</p>
            <span className="manage-license-filter-indicator">Click to filter table</span>
          </div>
        ))}

        <div className="manage-license-card manage-license-add-card" onClick={() => navigate("/license/add")}>
          <h3>+ Add New License</h3>
          <p>Create & Assign</p>
          <span className="manage-license-filter-indicator">Open Creator Wizard</span>
        </div>
      </div>

      {/* অ্যাকশন বার */}
      <div className="manage-license-table-actions-bar">
        <div className="manage-license-search-box-wrapper">
          <svg className="manage-license-search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            placeholder={`Search ${selectedStatus !== 'all' ? selectedStatus : ''} licenses by client, key, or network...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="manage-license-search-input"
          />
        </div>
        <div className="manage-license-active-filter-badge">
          Showing: <strong>{selectedStatus.toUpperCase()}</strong>
        </div>
      </div>

      {/* ডাটা টেবিল সেকশন */}
      {tableLoading ? (
        <div className="manage-license-loading-spinner-wrapper">
          <div className="manage-license-spinner"></div>
          <p>Loading license ledger...</p>
        </div>
      ) : (
        <div className="manage-license-responsive-table-wrapper">
          <table className="manage-license-pro-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Client Name</th>
                <th>Network</th>
                <th>License Key</th>
                <th>Status</th>
                <th>Device ID</th>
                <th>Expiry Date</th>
                <th style={{ textAlign: "center" }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredLicenses.length > 0 ? (
                filteredLicenses.map((l) => (
                  <tr key={l.id}>
                    <td className="manage-license-text-bold">#{l.id}</td>
                    <td>
                      <div className="manage-license-client-name-cell">{l.client_name || "N/A"}</div>
                    </td>
                    <td>
                      <span className="manage-license-network-badge">{l.network_name || "N/A"}</span>
                    </td>
                    <td>
                      <code className="manage-license-key-display-block" title={l.license_key}>
                        {l.license_key ? `${l.license_key.substring(0, 18)}...` : "—"}
                      </code>
                    </td>
                    <td>
                      <span className={`manage-license-status-badge ${l.status || "unknown"}`}>
                        {l.status || "Unknown"}
                      </span>
                    </td>
                    <td>
                      <span className="manage-license-device-id-text" title={l.device_id}>
                        {l.device_id || "Not Activated"}
                      </span>
                    </td>
                    <td>
                      <span className="manage-license-expiry-date-text">
                        {l.expiry_date ? new Date(l.expiry_date).toLocaleDateString() : "—"}
                      </span>
                    </td>
                    <td>
                      <div className="manage-license-table-row-actions">
                        <button
                          className="manage-license-btn-row-action manage-license-btn-copy"
                          onClick={() => {
                            navigator.clipboard.writeText(l.license_key);
                            alert("License key copied to clipboard!");
                          }}
                          title="Copy Key"
                        >
                          Copy
                        </button>
                        <button
                          className="manage-license-btn-row-action manage-license-btn-edit"
                          onClick={() => navigate("/update-license", { state: { license: l } })}
                          title="Edit License"
                        >
                          Edit
                        </button>
                        <button
                          className="manage-license-btn-row-action manage-license-btn-revoke"
                          onClick={() => alert("Revoke API will be integrated here.")}
                          title="Revoke License"
                        >
                          Revoke
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="manage-license-no-data-cell">
                    No licenses found matching the selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ManageLicense;